import CircleAlert from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/circle-alert.mjs";
import CircleCheck from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/circle-check.mjs";
import Info from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/info.mjs";
import TriangleAlert from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/triangle-alert.mjs";
import WifiOff from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/wifi-off.mjs";
import type { ReactNode } from "react";

import { cx } from "../cx";

export type BannerTone = "info" | "warning" | "danger" | "offline" | "success";

export interface BannerProps {
  tone?: BannerTone;
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
  /** `role="status"` (default). Off when the banner sits inside another live region. */
  live?: boolean;
}

const TONES: Record<BannerTone, string> = {
  info: "bg-info-soft text-info",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  offline: "border border-border bg-surface text-text",
  success: "bg-success-soft text-success",
};

const ICONS = {
  info: Info,
  warning: TriangleAlert,
  danger: CircleAlert,
  offline: WifiOff,
  success: CircleCheck,
} as const;

/** Inline notice band (FE-02 Banner), announced politely with role="status". */
export function Banner({
  tone = "info",
  title,
  children,
  action,
  className,
  live = true,
}: BannerProps) {
  const Icon = ICONS[tone];
  return (
    <div
      role={live ? "status" : undefined}
      className={cx("flex items-start gap-3 rounded-lg px-4 py-3", TONES[tone], className)}
    >
      <Icon aria-hidden="true" size={20} className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{title}</p>
        {children ? <div className="mt-1 text-sm text-text">{children}</div> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
